import { useEffect } from 'react'
import { initMetaPixel, trackViewContentOnce } from '../utils/metaPixel'

/**
 * Initializes the Meta Pixel, then fires PageView (base code) and ViewContent
 * for the Girls Flag Football Coach System™ product page.
 *
 * Both events are guarded at window level, so a remount, a hot reload or a
 * second mount of App cannot fire them twice. ViewContent is deferred to the
 * next task so PageView is always the first tracked event of the session.
 */
export function useMetaPixel(): void {
  useEffect(() => {
    initMetaPixel()

    const timer = window.setTimeout(() => {
      trackViewContentOnce()
    }, 0)

    return () => window.clearTimeout(timer)
  }, [])
}
